






















import { defineComponent } from '@vue/composition-api'
import TeamCardParts from '@/components/common/card/TeamCardParts.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'

/**
 * マイページ: トップ お気に入りチーム セクション
 * todo: チームデータ受渡
 */
export default defineComponent({
  name: 'MypageFavoriteTeamLinkSection',
  components: {
    TeamCardParts,
    AtomRouterButton,
  },
  props: {
    /**
     * お気に入りチーム名
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * お気に入りチーム画像
     */
    img: {
      type: String,
    },
    /**
     * 選択変更有効化
     */
    enabledSelect: {
      type: Boolean,
      default: true,
    },
  },
  methods: {},
})
